import { render, staticRenderFns } from "./Kinds.vue?vue&type=template&id=63284d88&scoped=true&"
import script from "./Kinds.vue?vue&type=script&lang=js&"
export * from "./Kinds.vue?vue&type=script&lang=js&"
import style0 from "./Kinds.vue?vue&type=style&index=0&id=63284d88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63284d88",
  null
  
)

export default component.exports